// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Edit from "@flip/XDL/Icons/Edit";
import { createLinkIconStyles } from "@flip/XDL/Utilities/sharedStyles";
import { accountSettingsDefaultBillingShippingStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsDefaultBillingShipping";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

accountSettingsDefaultBillingShippingStyles.defaultBillingShippingTitle = {
    variant: "h3",
    as: "h3",
};

accountSettingsDefaultBillingShippingStyles.defaultShippingRadioGridItem = {
    width: 12,
    css: css`
        && {
            padding-top: 22px;
        }
    `,
};

accountSettingsDefaultBillingShippingStyles.headingText = {
    variant: "h5",
    css: css`
        width: 100%;
        margin-bottom: 9px;
    `,
};
